import React, { useState } from "react";
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
  IconButton,
} from "@material-ui/core";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      border: `1px solid #C5C5C5`,
      borderRadius: 4,
      backgroundColor: "#F9F9F9",
      padding: theme.spacing(3),
      marginTop: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
        border: 0,
        paddingLeft: 0,
      },
    },
    title: {
      fontWeight: "bold",
      color: "#37474F",
      fontSize: 18,
      marginBottom: theme.spacing(2),
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(1, 0),
      justifyContent: "flex-start",
      textTransform: "none",
      backgroundColor: "#FFFFFF",
      color: "#37474F",
      borderColor: "#B0BEC5",
      borderWidth: 1,
      borderStyle: "solid",
      "&:hover": {
        backgroundColor: "#ECEFF1",
      },
      "& svg": {
        marginRight: theme.spacing(1),
      },
    },
    linkText: {
      fontSize: 16,
      fontWeight: 500,
    },
    fallbackContainer: {
      textAlign: "center",
      padding: theme.spacing(4),
    },
    fallbackMessage: {
      fontSize: 18,
      color: "#37474F",
    },
    linkCard: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(2),
      borderRadius: theme.spacing(1),
      border: `1px solid #E0E0E0`,
      backgroundColor: "#FFFFFF",
      transition: "box-shadow 0.2s ease-in-out",
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
      },
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 48,
      height: 48,
      borderRadius: "50%",
      backgroundColor: "#ECEFF1",
      marginRight: theme.spacing(2),
    },
    linkTextContainer: {
      flexGrow: 1,
    },
    linkLabel: {
      fontSize: 16,
      fontWeight: 500,
      color: "#37474F",
    },
    iconButton: {
      marginLeft: theme.spacing(1),
    },
    infoText: {
      color: "#37474F",
      fontSize: 16,
      marginBottom: theme.spacing(2),
      lineHeight: 1.5,
    },
    iframeContainer: {
      width: "100%",
      height: "800px",
      border: "none",
      marginTop: theme.spacing(4),
    },
  })
);

type LinkItem = {
  label: string;
  url: string;
};

const CiscoMeetingSpacesPerth = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mdAndUp = useMediaQuery(theme.breakpoints.up("md"));
  const [selectedUrl, setSelectedUrl] = useState<string | null>(null);

  const links: LinkItem[] = [
    {
      label: "Level 29 ",
      url: "https://workspaces.ciscospaces.io/?token=dcdaba0c-757f-473f-9204-815d06440285",
    },
    {
      label: "Level 30 ",
      url: "https://workspaces.ciscospaces.io/?token=52ae7d27-e215-4620-8d07-1f68367b508c",
    },
    {
      label: "Level 31 ",
      url: "https://workspaces.ciscospaces.io/?token=f99398b1-53a2-4141-aef0-e2f168629ce7",
    },
    {
      label: "Level 32 ",
      url: "https://workspaces.ciscospaces.io/?token=57649486-c06a-4e0a-a5fc-987816de9b0e",
    },
    {
      label: "Level 33 ",
      url: "https://workspaces.ciscospaces.io/?token=d3783fc1-cb51-4b31-b08f-829ab863f7da",
    },
    // {
    //   label: "Level 34 ",
    //   url: "https://workspaces.dnaspaces.io/?token=4bb99a36-1012-414b-bea4-8d2578a3a390#/dashboard",
    // },
    // {
    //   label: "Level 35 ",
    //   url: "https://workspaces.dnaspaces.io/?token=0daa4848-1f16-4105-b05d-79dd0dd06cd9#/dashboard",
    // },
    {
      label: "Level 36 ",
      url: "https://workspaces.ciscospaces.io/?token=6beaa677-1e9f-420d-8366-f6475adb144e",
    },
    {
      label: "Level 37 ",
      url: "https://workspaces.ciscospaces.io/?token=e8f10133-6efb-403e-aab7-6de08d9d7251",
    },
    {
      label: "Level 38 ",
      url: "https://workspaces.ciscospaces.io/?token=e126dcf2-bc27-474e-b000-d5c95d8533c3",
    },
    {
      label: "Level 39 ",
      url: "https://workspaces.ciscospaces.io/?token=da088ae1-c611-4c65-865f-9193dffcdb2b",
    },
    {
      label: "Level 40 ",
      url: "https://workspaces.ciscospaces.io/?token=3a444eb1-6ff4-43cb-a23a-22604fe34195",
    },
    {
      label: "Level 41 ",
      url: "https://workspaces.ciscospaces.io/?token=1321ba89-92fc-4077-8dfb-44c82236a1a8",
    },
    {
      label: "Level 42 ",
      url: "https://workspaces.ciscospaces.io/?token=de4abaa9-099f-4ae8-8ab0-ef90c50a12f1",
    },
    {
      label: "Level 43 ",
      url: "https://workspaces.ciscospaces.io/?token=949b92de-83b0-464f-9bf4-2b2d2f98e180",
    },
    {
      label: "Level 44 ",
      url: "https://workspaces.ciscospaces.io/?token=5f3ab136-b4e3-4bd2-bf13-71fd8117601d",
    },
    {
      label: "Level 45 ",
      url: "https://workspaces.ciscospaces.io/?token=372f575e-5adc-4c6a-b32c-1517e7e87a77",
    },
  ];

  const handleLinkClick = (url: string) => {
    setSelectedUrl(url);
  };

  return (
    <Box className={classes.container}>
      {selectedUrl ? (
        <Box>
          {/* <Typography variant="h6">Building Kiosk</Typography> */}
          <iframe src={selectedUrl} className={classes.iframeContainer} title="Kiosk" />
          <Box mt={2}>
            <IconButton onClick={() => setSelectedUrl(null)}>
              <LaunchIcon style={{ color: "#455A64" }} />
            </IconButton>
            <Typography>Click here to go back to the list of buildings</Typography>
          </Box>
        </Box>
      ) : (
        <>
          <Typography className={classes.infoText}>
            {" "}
            The Cisco Spaces Kiosks allow you to locate meeting spaces on the floor and hold an
            available meeting space for a short period of time, allowing you to walk in and occupy
            the space.{" "}
          </Typography>{" "}
          <Typography className={classes.infoText} style={{ fontStyle: "italic" }}>
            {" "}
            Cisco Spaces is in the progress of being rolled out to all BHP corporate office
            locations. Where your location is not available below, please await communications from
            your local Property and Workplace team regarding the Cisco Spaces rollout in your
            location.{" "}
          </Typography>{" "}
          <Typography className={classes.infoText}>
            {" "}
            Please click one of the links below to access the buildings kiosk page.{" "}
          </Typography>
          <Grid container spacing={2}>
            {links.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Paper
                  className={classes.linkCard}
                  onClick={() => handleLinkClick(item.url)}
                  elevation={0}
                >
                  <div className={classes.iconWrapper}>
                    <LocationCityIcon style={{ color: "#455A64" }} />
                  </div>
                  <div className={classes.linkTextContainer}>
                    <Typography className={classes.linkLabel}>{item.label}</Typography>
                  </div>
                  <IconButton
                    className={classes.iconButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLinkClick(item.url);
                    }}
                  >
                    <LaunchIcon style={{ color: "#455A64" }} />
                  </IconButton>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default CiscoMeetingSpacesPerth;
